import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "onlinePaused",
  "use": "onlinePaused-usage",
  "viewBox": "0 0 18 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 20\" id=\"onlinePaused\"><rect width=\"14\" height=\"14\" x=\"1\" y=\"5\" rx=\"7\" /><path d=\"M8 11v1h8.996V8.233H13.65l3.163-4.411L17 3.56V1H8.004v3.767h3.346L8.187 9.178 8 9.44V11Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol